// Modal de confirmación para cerrar manualmente la última oportunidad
import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import BaseModal from './BaseModal';

const CloseLastChanceModal = ({ property, onConfirm, onCancel }) => {
  return (
    <BaseModal
      onClose={onCancel}
      title="Cerrar Última Oportunidad"
      icon={<Clock className="w-6 h-6 text-amber-400" />}
      iconBg="bg-amber-500/20"
      borderColor="border-amber-500/30"
      footer={
        <>
          <button
            onClick={onCancel}
            className="flex-1 bg-slate-700 text-white font-medium py-3 rounded-lg hover:bg-slate-600 transition-all"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 bg-gradient-to-r from-amber-500 to-amber-600 text-slate-900 font-semibold py-3 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all"
          >
            Confirmar Cierre
          </button>
        </>
      }
    >
      <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-amber-200 mb-2">
            <strong>¿Estás seguro de cerrar manualmente el periodo de última oportunidad?</strong>
          </p>
          <p className="text-xs text-amber-300/80">
            Esta acción cerrará inmediatamente el periodo de última oportunidad para la propiedad:
          </p>
        </div>
      </div>

      <div className="bg-slate-700/30 rounded-lg p-4">
        <p className="text-white font-semibold text-center">
          {property.title}
        </p>
      </div>

      <div className="text-sm text-slate-400 space-y-2">
        <p>✅ Los pujadores no podrán realizar más ajustes</p>
        <p>✅ El estado cambiará a "Finalizado"</p>
        <p>✅ Podrás proceder con el ganador actual</p>
      </div>
    </BaseModal>
  );
};

export default CloseLastChanceModal;
